import React from 'react';

export const Nav = () => {
    return (
        <nav id="navbar">
            <div className="title">Who Tweeted That?</div>
        </nav>
    );
}